import { render, staticRenderFns } from "./SlotTruncator.vue?vue&type=template&id=e088b8f4&scoped=true"
import script from "./SlotTruncator.vue?vue&type=script&lang=js"
export * from "./SlotTruncator.vue?vue&type=script&lang=js"
import style0 from "./SlotTruncator.vue?vue&type=style&index=0&id=e088b8f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e088b8f4",
  null
  
)

export default component.exports